#import '../fragments/lead-goal-fragment.graphql'

query GetGoalsByStage($leadId: ID!) {
    lead(id: $leadId) {
        id
        stages {
            current {
                id
            }
            edges {
                ...LeadGoalFragment
            }
        }
    }
}
